module.exports = __webpack_public_path__ + "static/media/view6.d6188710.jpg";